import React from 'react';
import { BannerAction } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { closeModal } from '../../../Utils';
import { aemPageLinks } from '../../shared/Links';
import { dispatchOverlayLoad } from '../../shared/Analytics';

const viewFAQClick = (link) => {
    window.open(link, '_blank')
    dispatchOverlayLoad('View FAQs Link Click');
};

const cancelClick = () => {
    closeModal('banner-faq-modal');
};

const FAQModal = () => {
    return (
        <BannerAction
            id={'banner-faq'}
            title={'View frequently asked questions'}
            text={'Answer your questions about T. Rowe Price Retirement Advisory Service™.'}
            leftButtonText={'Cancel'}
            rightButtonText={'View FAQs'}
            createClick={() => viewFAQClick(aemPageLinks.faqLink)}
            cancelClick={cancelClick}
        />
    )
};

export default FAQModal;
